import { LandingTitle, Loader, PageLayout } from "../../components/index";
import { images } from "../../utils/images";
import NewsList from "./newsList/NewsList";
import axios from "axios";
import { baseUrl, getNews } from "../../utils/apiData";
import { useState, useEffect, Fragment } from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const News = () => {
  const [loader, setLoader] = useState(false);
  const [newsList, setNewsList] = useState([]);

  // Get News List APi
  const getNewsDataApi = async () => {
    setLoader(true);
    try {
      const res = await axios.get(`${baseUrl}/${getNews}`);
      if (res?.data?.success) {
        setNewsList(res?.data?.data);
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  useEffect(() => {
    getNewsDataApi();
  }, []);

  return (
    <PageLayout>
      <Helmet>
        <title>Events | Exotic Group</title>
        <meta name="description" content="Events | Exotic Group" />
      </Helmet>

      {loader ? (
        <Loader />
      ) : (
        <Fragment>
          <LandingTitle
            bgImage={images.galleryLanding}
            title="Events"
            para="Discover our latest events, conferences, and industry meetups."
          />
          <NewsList newsList={newsList} />
        </Fragment>
      )}
    </PageLayout>
  );
};

export default News;
